<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-card>
            <v-card-title class="">
                <h3>Session Expire Warning</h3>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        Your session is about to expire due to inactivity.
                    </v-flex>
                    <v-flex xs12 style="display: block;">
                        You will be automatically logged out in <span id="timeout-seconds">{{time / 1000}}</span> seconds.
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions py-1>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="stayLoggedIn()">Stay Logged In</v-btn>
                <v-btn class="secondary" @click="logout()">Logout</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'timeout-modal',
    props: {
        auth: { default: null },
        authenticated: { default: false }
    },
    data: function () {
        return {
            showDialog: false,
            time: 60000,
            checkIdleId: null,
            timeOutId: null
        }
    },
    created () {
        this.startTimeoutCheck()
    },
    methods: {
        startTimeoutCheck: function () {
            this.checkIdleId = setInterval(() => {
                if (!this.$store.state.idleVue.isIdle) return
                clearInterval(this.checkIdleId)
                if (this.authenticated) this.startTimeout()
            }, 1000)
        },
        startTimeout: function () {
            this.time = 60000
            this.showDialog = true
            this.timeOutId = setInterval(() => {
                this.time -= 1000
                if (this.time < 1) {
                    clearInterval(this.timeOutId)
                    this.show = false
                    this.auth.logout()
                }
            }, 1000)
        },
        logout () {
            clearInterval(this.checkIdleId)
            clearInterval(this.timeOutId)
            this.showDialog = false
            this.auth.logout()
        },
        stayLoggedIn () {
            clearInterval(this.checkIdleId)
            clearInterval(this.timeOutId)
            this.startTimeoutCheck()
            this.showDialog = false
            //this.auth.renewTokens()
        }
    }
}
</script>

<style>
    #timeout-seconds {
        font-size: 18px;
        /* color: red; */
    }
</style>
